<div class="backpage-wrapper" >
  <div class="cred-library-content-creator">
    <div class="credential-library-container padding s6 all">
      <div class="header">
        <h1>Partner Management</h1>
        <p class="header-subtext">
          Invite and manage the Guest Purchasers in your revenue share
          program.
        </p>
      </div>
      <div class="invite-input">
        <form [formGroup]="inviteEmailForm" (ngSubmit)="onSubmit()">
          <mat-form-field
            appearance="outline"
            class="full-width custom-chip-field action-bar-field"
          >
            <mat-label>Invite Guest Purchasers</mat-label>

            <!-- 1. Lead Icon -->
            <mat-icon matPrefix class="lead-icon">person_add_alt_1</mat-icon>

            <mat-chip-grid #chipGrid aria-label="Email selection">
              @for (email of emails; track email) {
              <mat-chip-row (removed)="remove(email)" class="custom-chip">
                <mat-icon matChipAvatar>account_circle</mat-icon>
                {{ email }}
                <button matChipRemove><mat-icon>cancel</mat-icon></button>
              </mat-chip-row>
              }
              <input
                placeholder="Enter email addresses..."
                [matChipInputFor]="chipGrid"
                [matChipInputAddOnBlur]="true"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="add($event)"
                formControlName="emailInput"
              />
            </mat-chip-grid>

            <!-- 2. Styled Suffix Section -->
            <div matSuffix class="suffix-container">
              <div
                class="role-pill"
                matTooltip="Revenue sharing enabled for this role"
              >
                <mat-icon>verified_user</mat-icon>
                <span>GUESTPURCHASER</span>
              </div>

              <button
                mat-flat-button
                color="primary"
                type="submit"
                [disabled]="emails.length === 0"
              >
                <mat-icon>send</mat-icon>
                <span>Invite</span>
              </button>
            </div>

            <mat-hint>Separate emails with a comma or press Enter/Tab</mat-hint>
          </mat-form-field>
          @if (inviteErrorMessage) {
          <div class="error-message">
            <mat-icon>error_outline</mat-icon>
            <div class="error-content">
              <strong>Unable to Invite</strong>
              <p *ngIf="failedEmailMessages.length <= 1">{{ inviteErrorMessage }}</p>
              <ul class="failed-emails-list" *ngIf="failedEmailMessages.length > 1">
                @for (message of failedEmailMessages; track message) {
                <li>{{ message }}</li>
                }
              </ul>
            </div>
          </div>
          }
        </form>
      </div>
    </div>

    <div class="credential-library-container padding s6 all">
      <div class="header">
        <div class="header-with-search">
          <h1>Active Users</h1>
          <mat-form-field
            appearance="outline"
            floatLabel="always"
            class="search-field"
          >
            <mat-icon matPrefix>search</mat-icon>
            <mat-label>Search this page</mat-label>
            <input
              matInput
              (keyup)="applyFilter($event)"
              placeholder="Enter name or email"
              #input
            />
            @if (input.value) {
            <button
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="input.value = ''; applyFilter({ target: input })"
            >
              <mat-icon>close</mat-icon>
            </button>
            }
          </mat-form-field>
        </div>

        <!-- Card Grid Container -->
        <div class="user-card-grid">
          @for (user of dataSource.filteredData; track user.permissionId) {
          <div class="user-card">
            <!-- Top Section: Avatar and Actions -->
            <div class="card-header">
              <div
                class="avatar-circle large"
                [style.background-color]="
                  user.userName === 'Profile not created'
                    ? '#e0e0e0'
                    : getAvatarColor(user.userName)
                "
                [class.profile-missing]="
                  user.userName === 'Profile not created'
                "
              >
                @if (user.userName === 'Profile not created') {
                <!-- Warning/Alert Icon -->
                <mat-icon class="missing-icon">priority_high</mat-icon>
                } @else {
                {{ getInitials(user.userName) }}
                }
              </div>

              <button
                mat-icon-button
                [matMenuTriggerFor]="moreMenu"
                class="card-menu-btn"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
            </div>

            <!-- Middle Section: User Details -->
            <div class="card-content">
              <h3 class="user-name-text">{{ user.userName }}</h3>
              <p class="user-email-text">{{ user.email }}</p>
              <span class="role-badge">{{ user.Role }}</span>
            </div>

            <!-- Menu Definition (Reuse your existing menu) -->
            <mat-menu #moreMenu="matMenu">
              <button
                mat-menu-item
                (click)="deleteUser(user)"
                [disabled]="!user.canDelete"
                class="text-danger"
                [matTooltip]="
                  user.canDelete ? '' : 'You do not have permission to delete'
                "
              >
                <mat-icon color="warn">delete</mat-icon>
                <span>Delete User</span>
              </button>
            </mat-menu>
          </div>
          }@empty {
          <!-- Empty State when search returns nothing -->
          <div class="no-results">
            <mat-icon>search_off</mat-icon>
            <p>No users match "{{ input.value }}"</p>
          </div>
          }
        </div>
      </div>

      <mat-paginator
        [length]="totalRecords"
        [pageSize]="6"
        [pageSizeOptions]="[6, 12, 24]"
        (page)="onPageChange($event)"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</div>
